import React from "react";
import MediaCardWrapper from "AppComponents/Attachment/MediaCardWrapper/MediaCardWrapper";
import { Button, Tooltip } from "@toddle-edu/ds-web";
import { isSubmissionItemTemplate } from "Projects/modules/ProjectModules";
import { ATTACHMENT_TYPE_LINK } from "Constants/stringConstants";
import { useI18n } from "Hooks";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const UseTemplateMediaCard = props => {
  const {
    selectedProjectReportTemplate,
    disabled,
    containerStyle,
    onUseTemplateClick,
  } = props;

  const { t } = useI18n(["common", "project"]);

  const { parentProjectGroupReport, type, parentType: reportParentType } =
    selectedProjectReportTemplate || {};
  const parentType = parentProjectGroupReport?.type || reportParentType;

  const getViewModeExtraButtons = () =>
    isSubmissionItemTemplate(parentType) || type === ATTACHMENT_TYPE_LINK ? (
      <ConditionalWrapper
        condition={disabled}
        wrapper={
          <Tooltip tooltip={t("project:use_template_disabled_tooltip")} />
        }
        type={"wrapperAsElement"}
      >
        <Button
          variant="neutral"
          type="outlined"
          onClick={onUseTemplateClick}
          disabled={disabled}
        >
          {t("project:use_template")}
        </Button>
      </ConditionalWrapper>
    ) : null;

  return (
    <div style={containerStyle}>
      <MediaCardWrapper
        attachment={selectedProjectReportTemplate}
        mediaCardSize={"medium"}
        getViewModeExtraButtons={getViewModeExtraButtons}
        attachmentBottomComponent={() => {}}
        onClickAttachmentCard={() => {}}
        isDisabled={disabled}
        mode={"view"}
        dsVersion={"2.0"}
      />
    </div>
  );
};

export default UseTemplateMediaCard;
